import * as React from "react";
import classnames from "classnames";
import css from "./unsupported-browser.module.css";

const locales = {
  fr: {
    download: "Télécharger",
    updateOS: "Mettre à jour le système",
    title: "Désolé mais nous ne supportons plus ce navigateur 😔",
    msg1: "Vous voyez ce message parce que nous avons détecté que votre navigateur n'est plus pris en charge.",
    msg2: "Nous vous recommandons vivement de le mettre à jour car il pose des problèmes de sécurité.",
    reco: "Voici les possibilités que nous vous recommandons :",
  },
  en: {
    download: "Download",
    updateOS: "Update the system",
    title: "Sorry but we don't support this browser anymore 😔",
    msg1: "You are seeing this message because we have detected that your browser is no longer supported",
    msg2: "We strongly recommend that you update your browser because it has security issues.",
    reco: "Here are the features we recommend:",
  },
};

const browsers = {
  chrome: {
    icon: "chrome",
    message: "download",
    link: "https://www.google.com/chrome/",
  },
  firefox: {
    icon: "firefox",
    message: "download",
    link: "https://www.mozilla.org/fr/firefox/all/",
  },
  edge: {
    icon: "edge",
    message: "download",
    link: "https://www.microsoft.com/edge",
  },
  safari: {
    icon: "safari",
    message: "updateOS",
    link: "https://support.apple.com/HT201475",
  },
  safariMobile: {
    icon: "safari",
    message: "updateOS",
    link: "https://support.apple.com/HT204204",
  },
  chromeMobile: {
    icon: "chrome",
    message: "download",
    link: "https://play.google.com/store/apps/details?id=com.android.chrome",
  },
};

const platforms = {
  windows: [browsers.chrome, browsers.firefox, browsers.edge],
  mac: [browsers.chrome, browsers.firefox, browsers.safari],
  iOS: [browsers.safariMobile],
  android: [browsers.chromeMobile],
  other: [browsers.chrome, browsers.firefox],
};

const isIOS = () => {
  const iOSDevices = ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"];
  return (
    iOSDevices.indexOf(navigator.platform) !== -1 ||
    (navigator.userAgent.indexOf("Mac") !== -1 && "ontouchend" in document)
  );
};

const isAndroid = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf("android") > -1;
};

const isWindows = () => {
  return navigator.platform.toUpperCase().indexOf("WIN") !== -1;
};

const isMac = () => {
  return navigator.platform.toUpperCase().indexOf("MAC") !== -1;
};

const Browser = ({ icon, message, link, messages }) => {
  const imageUrl = `https://widget.msem.tech/images/browsers/${icon}.svg`;
  return (
    <a className={css.browser} href={link} target="_blank" rel="noopener noreferrer">
      <img className={css.browserIcon} src={imageUrl} width="64" height="64" alt="" />
      <span className={css.browserName}>{icon}</span>
      <span className={css.browserAction}>{messages[message]}</span>
    </a>
  );
};

const UnsupportedBrowser = ({ options }) => {
  const platform = isIOS() ? "iOS" : isAndroid() ? "android" : isWindows() ? "windows" : isMac() ? "mac" : "other";
  const lang = options.lang === "en" ? "en" : "fr";
  const messages = locales[lang];
  const backdropClasses = classnames(css.backdrop, {
    [css.grounded]: options.groundedTo !== undefined,
  });
  return (
    <div className={backdropClasses}>
      <div className={css.unsupported}>
        <div className={css.title}>{messages.title}</div>
        <div className={css.messages}>
          <p className={css.message}>{messages.msg1}</p>
          <p className={css.message}>{messages.msg2}</p>
        </div>
        <div className={css.reco}>{messages.reco}</div>
        <div className={css.browsers}>
          {platforms[platform].map((browser) => (
            <Browser key={browser.icon} messages={messages} {...browser} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default UnsupportedBrowser;
